const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, string>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (!match) return;

  const [, lang, ns] = match;

  if (!messages[lang]) {
    messages[lang] = {};
  }

  const module = modules[path] as Record<string, unknown>;

  // 优先使用 default 导出，否则用第一个命名导出对象
  if (module.default && typeof module.default === 'object' && module.default !== null) {
    messages[lang][ns] = module.default as Record<string, string>;
  } else {
    const namedKey = Object.keys(module).find(
      (k) => k !== 'default' && typeof module[k] === 'object' && module[k] !== null && !Array.isArray(module[k])
    );
    if (namedKey) {
      messages[lang][ns] = module[namedKey] as Record<string, string>;
    }
  }
});

export default messages;